import { CITATION_BRAND_COLORS } from '@/common/app/modules/media/citation'
import { CitationBrand } from '@/common/model/media/citation'

import Text, { TextColor } from '@/components/view/atoms/text/Text'
import ItemAlign from '@/components/view/layouts/item/ItemAlign'

interface Props {
  brands: CitationBrand[]
  // ブランドごとの言及総数（brands と同じ並び）。省略時は件数を出さない
  totals?: number[]
}

// チャートの系列色に対応したブランド凡例
const CitationBrandLegend = ({ brands, totals }: Props) => (
  <ItemAlign gapX={16} gapY={4} align='center'>
    {brands.map((brand, i) => (
      <ItemAlign key={i} gapX={4} align='center' nowrap>
        <div
          className='h-3 w-3 shrink-0 rounded-sm'
          style={{ background: CITATION_BRAND_COLORS[i % CITATION_BRAND_COLORS.length] }}
        />
        <Text size={12} color={TextColor.SECONDARY}>
          {brand.name}
          {totals?.[i] != null ? ` ${totals[i]}件` : ''}
        </Text>
      </ItemAlign>
    ))}
  </ItemAlign>
)

export default CitationBrandLegend
